<template>
  <div ref="chart" :style="{height, width}" />
</template>

<script>
import {debounce} from "@/utils/visual";

export default {
  name: "mulSchemeCompare",
  props: {
    chartData:{
      type: String,
      require: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '950px'
    },
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods:{
    initChart() {
        this.chart = this.$echarts.init(this.$refs.chart)
        this.setOptions()
    },
    setOptions() {
          let option = {
            title: {
              text: '水文站2',
              textStyle:{
                //文字颜色
                color:'#ccc',
                //字体风格,'normal','italic','oblique'
                fontStyle:'normal',
                //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                fontWeight:'bold',
                //字体系列
                fontFamily:'sans-serif',
                //字体大小
                fontSize:18
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: 'rgb(6,161,250)'
                },
                label: {
                  backgroundColor: 'rgb(6,161,250)'
                }

              }
            },
            legend: {
              data: ['实测流量','逐步多元回归模型-枯季径流总量方案', '多元回归模型-年径流总量方案', '多元回归模型-枯季径流总量方案', '自回归滑动平均模型-平均流量方案', '多元回归模型-秋汛期最大流量方案'],
              textStyle: {
                color: 'rgb(6,161,250)' // 设置字体颜色为红色
              },
              bottom: 0,         // 👈 把图例放到图表底部
              left: 'center',
              type: 'scroll',    // 支持滚动翻页
              orient: 'horizontal', // 横向排列

            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                dataView: {show: true, readOnly: false},
                magicType: {show: true, type: ['line', 'bar']},
                restore: {show: true},
                saveAsImage: {show: true}
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#4682B4'
                },
              },
              data: ["4:00", "5:00",  "6:00",  "7:00",  "8:00", "9:00",  "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00"]
            },
            yAxis: {
              name: '流量(m^3/s)',
              type: 'value',
              min:0,  //取0为最小刻度
              max: 1000, //取100为最大刻度
              // boundaryGap: [0, '100%'],
              splitLine: {
                show: false
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#4682B4'
                }
              }
            },
            series: [
              {
                name: '实测流量',
                type: 'line',
                smooth: true,
                symbolSize: 1,//去掉页面上显示的圆点
                itemStyle: {
                  normal: {
                    color: "red",
                    lineStyle: {
                      color: "red",
                    },
                  },
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'red'//下层渐变
                    }, {
                      offset: 0.8,
                      color: 'rgba(137, 189, 27, 0)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                    shadowBlur: 10
                  }
                },
                data: [100, 142, 161, 204, 300, 430, 598],
                lineStyle: { // 设置线条的style等
                  normal: {
                    color: 'red', // 折线线条颜色:红色
                  },
                },
              },
            ],
          };
      if(this.chartData!=='1'){
        option.series.push({
          name: '逐步多元回归模型-枯季径流总量方案',
          type: 'line',
          smooth: true,
          symbolSize: 1,//去掉页面上显示的圆点
          itemStyle: {
            normal: {
              color: "#00FFFF",
              lineStyle: {
                color: "#00FFFF",
              },
            },
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00FFFF'//下层渐变
              }, {
                offset: 0.8,
                color: 'rgba(137, 189, 27, 0)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          data: [null, null, null, null, null, null, 598, 820, 900, 640, 510, 370, 200],
          lineStyle: {
            normal: {
              type: 'dotted'
            }
          }
        })
    }else{
        option.series.push({
          name: '逐步多元回归模型-枯季径流总量方案',
          type: 'line',
          smooth: true,
          symbolSize: 1,//去掉页面上显示的圆点
          itemStyle: {
            normal: {
              color: "#00FFFF",
              lineStyle: {
                color: "#00FFFF",
              },
            },
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00FFFF'//下层渐变
              }, {
                offset: 0.8,
                color: 'rgba(137, 189, 27, 0)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          data: [null, null, null, null, null, null, 598, 820, 900, 640, 510, 370, 200],
          lineStyle: {
            normal: {
              type: 'dotted'
            }
          }
        },{
              name: '自回归滑动平均模型-平均流量方案',
              type: 'line',
              smooth: true,
              symbolSize: 1,//去掉页面上显示的圆点
              itemStyle: {
                normal: {
                  color: "yellow",
                  lineStyle: {
                    color: "yellow",
                  },
                },
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'yellow'//下层渐变
                  }, {
                    offset: 0.8,
                    color: 'rgba(137, 189, 27, 0)'
                  }], false),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10
                }
              },
              data: [null, null, null, null, null, null, 598, 720, 980, 690, 545, 310, 290],
              lineStyle: {
                normal: {
                  type: 'dotted'
                }
              }
            },{
              name: '多元回归模型-年径流总量方案',
              type: 'line',
              smooth: true,
              symbolSize: 1,//去掉页面上显示的圆点
              itemStyle: {
                normal: {
                  color: "green",
                  lineStyle: {
                    color: "green",
                  },
                },
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'green'//下层渐变
                  }, {
                    offset: 0.8,
                    color: 'rgba(137, 189, 27, 0)'
                  }], false),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10
                }
              },
              data: [null, null, null, null, null, null, 598, 520, 800, 940, 710, 670, 500],
              lineStyle: {
                normal: {
                  type: 'dotted'
                }
              }
            })
      }
      this.chart.setOption(option, true);
    }
  },
  watch: {
    chartData() {
      console.log("123")
      this.setOptions()
    }
  }
}
</script>

<style scoped>

</style>